import './Navbar.css'
function Navbar() {
    return(
        <div className="container navbar bg-light">
            <a href="/"><img className="img-fluid m-2" style={{height:'40px', width:'auto'}} src="/logo.png" alt="logo" /></a>
            
        </div>
    )
}
export default Navbar;